export const DEVICE_CONNECTIVITY_EVENT="netInfo.networkStatusDidChange";